import { IMotorsportsTabsSwitch, MotorsportsTabsSwitch } from "@sky-it-livedata/livedata-sports-design-system";
// import { graphql } from "cdk/graphql";

import transformQuery from "./transformers/query-transformer";
// import transformSubscription from "./transformers/subscription-transformer";
import { LgpResultsContainerQuery } from "./types";
import { log } from "../../utils/log";
// import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";

export const setCustomAttributes = ({variables}: WidgetContext<LgpResultsContainerQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

export const disableClientRender = true;

// const subscriptionDocument = graphql("subscription UpdateLgpResultsContainerWidget($seasonAndCompId: ID!, $gpId: ID!) {\n  onUpdateLgpResContainerBySeasonAndCompIdAndGpId(\n    seasonAndCompId: $seasonAndCompId\n    gpId: $gpId\n  ) {\n    FP1 {\n      ssi\n      startDateTime\n      customDataAttributes {\n        tracking\n        url\n      }\n    }\n    FP2 {\n      ssi\n      startDateTime\n      customDataAttributes {\n        tracking\n        url\n      }\n    }\n    FP3 {\n      ssi\n      startDateTime\n      customDataAttributes {\n        tracking\n        url\n      }\n    }\n    FP4 {\n      customDataAttributes {\n        tracking\n        url\n      }\n      startDateTime\n      ssi\n    }\n    G {\n      ssi\n      startDateTime\n      customDataAttributes {\n        tracking\n        url\n      }\n    }\n    GS {\n      ssi\n      startDateTime\n      customDataAttributes {\n        tracking\n        url\n      }\n    }\n    Q {\n      customDataAttributes {\n        tracking\n        url\n      }\n      ssi\n      startDateTime\n    }\n    QS {\n      customDataAttributes {\n        tracking\n        url\n      }\n      ssi\n      startDateTime\n    }\n    R {\n      customDataAttributes {\n        tracking\n        url\n      }\n      ssi\n      startDateTime\n    }\n    SPRINT {\n      customDataAttributes {\n        tracking\n        url\n      }\n      ssi\n      startDateTime\n    }\n    gpId\n    seasonAndCompId\n    __typename\n    createdAt\n    updatedAt\n    competitionId\n    seasonId\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<LgpResultsContainerQuery>): IMotorsportsTabsSwitch {
  return transformQuery(props);
}

const LgpResultsContainer = ({props,
  variables,
  ...rest
}: WidgetContext<IMotorsportsTabsSwitch>) => {
  log({ props, variables, ...rest });

//   const updatedProps = useSubscription<
//     IMotorsportsTabsSwitch,
//     LgpResultsContainerSubscription,
//     typeof subscriptionDocument
//   >({
//     initialData: props,
//     graphQLDocument: subscriptionDocument,
//     variables,
//     transform: transformSubscription,
//     mergeData: false,
//   }) as IMotorsportsTabsSwitch;

  return <MotorsportsTabsSwitch {...props}/>;
}

export default LgpResultsContainer;